import { Button, ButtonProps } from '@braskai/ui-kit';

import { styled } from '@mui/material';

export const SubmitButton = styled((props: ButtonProps) => <Button size="xl" {...props} />)({
  height: 52,
});
